import { useCallback, useState } from 'react';
export const useBooleanState = (initialValue = false) => {
    const [value, setValue] = useState(initialValue);
    const setTrue = useCallback(() => setValue(true), []);
    const setFalse = useCallback(() => setValue(false), []);
    const toggle = useCallback(() => setValue((currentValue) => !currentValue), []);
    return [value, setTrue, setFalse, toggle];
};
